class SicknessLeaveDateController {
  constructor(EventEmitter, $scope) {
    'ngInject';
    this.eventEmitter = EventEmitter;
    this.scope = $scope;
    this.sicknessLeaveDateKnownCheck = false;
  }

  $onInit() {
    this.setMinDateInMobile();
  }

  setMinDateInMobile() {
    if(this.isMobileApp) {
      this.scope.$watch(() => this.minDate,() => {
        this.minSicknessLeaveDate = this.minDate;
      });  
    }
  }

  getClassWhenRelapseIsActive() {
    return {
      'leave-date-known-form': this.isRelapse && !this.isMobileApp,
      'leave-date-known-form mobile': this.isRelapse && this.isMobileApp,
      'responsiveMobile': !this.isRelapse && this.isMobileApp
    };
  }

  onDatepickLeaveDateKnown($event) {
    this.datepickLeaveDateKnown(this.eventEmitter({date: $event.date}));
  }

  onChangeLeaveDateCheckbox(){
    this.setLeaveDateSendStatus(this.eventEmitter({selected: this.sicknessLeaveDateKnownCheck}));
  }

  onSelectSicknessLeaveDateKnownReason($event) {
    this.selectSicknessLeaveDateKnownReason(this.eventEmitter({value: $event.$item.value})); 
  }
}

export default SicknessLeaveDateController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/sicknessLeaveDate/sicknessLeaveDate.controller.js